import ENDPOINTS from "../ApiManager/PaisEndPoints";
import environment from "../environments/environment";

const BASE_URL = environment.api_url;

class PaisService {
	
	static getPaises = () => {
		const url = BASE_URL + ENDPOINTS.GET_PAISES();
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
          		'Content-Type': 'application/json',
			}
		});
	};	
}

export default PaisService;